/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';


@Injectable({ providedIn: 'root' })
export class WorkAppConfigV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appConfigV2ControllerGetAppConfig()` */
  static readonly AppConfigV2ControllerGetAppConfigPath = '/v2/app-config';

  /**
   * Modul-Aktivierung dieses Tenants (vom worksuite-admin geladen, Cache-TTL 5 Min).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appConfigV2ControllerGetAppConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  appConfigV2ControllerGetAppConfig$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAppConfigV2Service.AppConfigV2ControllerGetAppConfigPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Modul-Aktivierung dieses Tenants (vom worksuite-admin geladen, Cache-TTL 5 Min).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appConfigV2ControllerGetAppConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appConfigV2ControllerGetAppConfig(
    params?: {
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.appConfigV2ControllerGetAppConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
